import React, { FunctionComponent } from 'react'
import styled, { ITheme } from '../../../../theme'
import { IWithSize } from '../../../../containers/BookingCalendar/Calendar/Calendar'
import { FlexibleText } from '../../../Template/Typography'

const LabelContainer = styled.div`
  display: flex;
  min-width: 0;
  width: 100%;
`

const LabelText = styled.span<IWithSize>`
  font-size: ${({ size }) => (size ? 18 * size : 16)}px;
  font-weight: 500;
  overflow-wrap: break-word;
  overflow: hidden;
`

const InfoLabelText = styled(FlexibleText as any)<IWithSize>`
  font-size: ${({ size }) => (size ? 16 * size : 16)}px;
  letter-spacing: 0.2px;
  color: ${(props: ITheme) => props.theme.colors.palette.darkGreyTwo};
  margin-left: ${({ size }) => (size ? 20 * size : 20)}px;
`

const InfoLabel: FunctionComponent<any> = ({ children, size = 1 }: any) => (
  <LabelContainer>
    <InfoLabelText size={size}>{children}</InfoLabelText>
  </LabelContainer>
)

const Label: FunctionComponent<any> = ({ children, size = 1 }: any) => (
  <LabelContainer>
    <LabelText size={size}>{children}</LabelText>
  </LabelContainer>
)

export { Label, InfoLabel }
